import React from "react";

export default function SQL_COLUMN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_COLUMN</h1>
      <p>This is the SQL_COLUMN component generated from the SQL JSON.</p>
    </div>
  );
}
